@if (!!story() && !!options()) {
    <div class="ft-broadcast-editor">
        <div class="ft-row">
            <div class="ft-col-66">
                <div class="ft-preview-container template">
                    <div class="ft-preview" [class]="{'quote-only': !options().isShowGuestPhoto, 'show-quote': options().isShowGuestQuote, 'show-caption': (options().isShowPhotoCaption && !!options().isGuestPhoto), 'landscape': options().isLandscape, 'portrait': !options().isLandscape, 'ft-rtl': options().isRtl}">
                        <!-- Blurred images display if portrait images -->
                        @if (options().isShowGuestPhoto && !options().isLandscape) {
                            <div class="ft-bg-image-blur"
                                 [style.background-image]="'url(' + azurePhoto(story().guest.poststay.photo, 'small') + ')'"></div>
                        }
                        @if (!options().isShowGuestPhoto && !options().isLandscape) {
                            <div class="ft-bg-image-blur"
                                 [style.background-image]="'url(' + property().BackgroundImageUrl + ')'"></div>
                        }

                        @if (options().isShowGuestPhoto) {
                            <div class="ft-bg-image"
                                 [style.background-image]="'url(' + azurePhoto(story().guest.poststay.photo, 'small') + ')'"></div>
                        }
                        @if (!options().isShowGuestPhoto) {
                            <div class="ft-bg-image"
                                 [style.background-image]="'url(' + property().BackgroundImageUrl + ')'"></div>
                        }
                        <div class="ft-bg-matte"></div>

                        <div class="ft-story-info">
                            <ft-image-ng [src]="story().guest.profileImageUrl" [profilePhoto]="true" [alwaysVisible]="true"
                                         [silhouetteClass]="story().guest.silhouetteClass" [hidden]="!options().isShowProfilePic" />
                            <div class="ft-person-name" [hidden]="!options().isShowGuestName">
                                {{ story().guest | fullName:true }}
                            </div>
                            @if (!!(story().guest.poststay.quote?.notesPositive) && !storyDescriptor()?.isHotelRatedNegativeQuote()) {
                                <div class="ft-story-quote ft-text-plus-1"
                                     [hidden]="!options().isShowGuestQuote">
                                    &ldquo;{{ story().guest.poststay.quote.notesPositive | truncate:quoteSize:true }}&rdquo;
                                </div>
                            }
                            @if (storyDescriptor()?.hasPhoto() && !storyDescriptor()?.isHotelRatedNegativeCaption()) {
                                <div class="ft-story-photocaption"
                                     [hidden]="!options().isShowPhotoCaption || !options().isShowGuestPhoto">
                                    {{ story().guest.poststay.photo.caption | truncate:captionSize:true }}
                                </div>
                            }
                        </div>

                    </div>
                </div>
            </div>

            <div class="ft-col-33">
                <div class="ft-editor-options">
                    <div class="ft-option">
                        <label class="ft-label">{{ 'flipto.account.Template' | translate }}</label>
                        <div class="ft-dropdown opens-right" [class.active]="dropdownOpen()" (click)="toggleDropdown($event)">
                            <a class="ft-dropdown-toggle">
                                @if (options().isShowGuestPhoto) {
                                    <span>
                                        {{ 'flipto.account.GuestPhoto' | translate }}
                                    </span>
                                }
                                @if (!options().isShowGuestPhoto) {
                                    <span>
                                        {{ 'flipto.account.HotelPhoto' | translate }}
                                    </span>
                                }
                                <i class="ft-icn-caret-down"></i>
                            </a>
                            <ul class="ft-dropdown-menu">
                                @if (storyDescriptor()?.hasPhoto()) {
                                    <li [class.active]="options().isShowGuestPhoto">
                                        <a (click)="options().isShowGuestPhoto = true">
                                            {{ 'flipto.account.GuestPhoto' | translate }}
                                        </a>
                                    </li>
                                }
                                <li [class.active]="!options().isShowGuestPhoto">
                                    <a (click)="options().isShowGuestPhoto = false">
                                        {{ 'flipto.account.HotelPhoto' | translate }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="ft-option">
                        <label class="ft-label">{{ 'flipto.account.GuestProfilePic' | translate }}</label>
                        <ft-switch [(state)]="options().isShowProfilePic" />
                    </div>
                    <div class="ft-option">
                        <label class="ft-label">{{ 'flipto.account.GuestName' | translate }}</label>
                        <ft-switch [(state)]="options().isShowGuestName" />
                    </div>
                    @if (storyDescriptor()?.hasPositiveQuote() && !storyDescriptor()?.isHotelRatedNegativeQuote()) {
                        <div class="ft-option">
                            <label class="ft-label">{{ 'flipto.account.sections.platform.photoAdvocacy.Quote' | translate }}</label>
                            <ft-switch [(state)]="options().isShowGuestQuote" />
                        </div>
                    }
                    @if (story().guest.poststay.photo && options().isShowGuestPhoto && storyDescriptor()?.hasCaption() && !storyDescriptor()?.isHotelRatedNegativeCaption()) {
                        <div class="ft-option">
                            <label class="ft-label">{{ 'flipto.account.PhotoCaption' | translate }}</label>
                            <ft-switch [(state)]="options().isShowPhotoCaption" />
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
